function parseIniString(string){
// DON'T TAB THIS LINE... (let jump)
let jump = `
`;
    let parts = string.split(jump);
    let results = {};
    parts.map(( part )=>{
        let strings = part.split("=");
        if(typeof strings[1] !== "undefined"){
            results[strings[0]] = strings[1];
        }
    })    
    return results;
}

export {parseIniString} 